module.exports = __webpack_public_path__ + "static/media/transporter-3.f1ac1784.svg";